// defaultFormDataBank.js
// Valeurs initiales pour le formulaire Crédit Bancaire

const defaultFormDataBank = {
  // 1. Informations personnelles
  nom: "",
  prenom: "",
  dateNaissance: "",
  adresse: "",
  telephone: "",
  email: "",
  familyComposition: "",
  passport: "",

  // 2. Informations professionnelles
  profession: "",
  typeContrat: "",    // "CDD" | "CDI" | "indépendant" | "autre"
  anciennete: "",     // en mois
  salaireNet: "",     // en €

  // 3. Détails du crédit bancaire
  typeCredit: "",     // "auto" | "immobilier" | "personnel" | "autre"
  montantCredit: "",  // en €
  apport: "",         // en €
  creditsEnCours: "", // "oui" | "non"

  // 4. Garant éventuel
  aGarant: "",        // "oui" | "non"

  // 5. Aide du conjoint
  aideConjoint: "",   // "oui" | "non"

  // 6. Données d’authentification / métadonnées
  userEmail: "",
  userEpay: false,
  userId: "",

  // 7. Marqueur de type de formulaire
  formulaire: "banque",
};

export default defaultFormDataBank;
